import { addMetaDataProperties } from "./serializer/add-metaData-properties";
import { removeDateTimeType } from "./serializer/remove-datetime-type";
import { removeTagboxType } from "./serializer/remove-tagbox-type";

export function configureSerializer() {
    removeDateTimeType();
    removeTagboxType();
    addMetaDataProperties();
}